import { render } from "./SampleUploadEditModal.vue?vue&type=template&id=1f187aa1"
import script from "./SampleUploadEditModal.vue?vue&type=script&lang=js"
export * from "./SampleUploadEditModal.vue?vue&type=script&lang=js"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__